import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useButtonStyles = makeStyles<Theme>(theme => ({
  formButton: {
    '&&': {
      fontFamily: theme.typography.fontFamily,
      outline: '0',
      background: theme.palette.primary.main,
      width: '100%',
      maxWidth: 'fit-content',
      border: '1px transparent solid',
      padding: '8px 30px',
      color: theme.palette.primary.light,
      fontSize: '0.7rem',
      transition: 'all 0.3 ease',
      borderRadius: '5px',
      cursor: 'pointer',
      textTransform: 'initial'
    },
    '&&:hover': {
      background: '#949494'
    },
    '&&:disabled, &&.Mui-disabled': {
      background: '#949494',
      borderColor: '#949494',
      color: theme.palette.primary.light,
      filter: 'grayscale(100%)',
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  },
  formButtonSecondary: {
    '&&': {
      fontFamily: theme.typography.fontFamily,
      outline: '0',
      background: theme.palette.secondary.main,
      width: '100%',
      maxWidth: 'fit-content',
      border: `1px solid ${theme.palette.secondary.contrastText}`,
      padding: '8px 30px',
      color: theme.palette.secondary.contrastText,
      fontSize: theme.typography.fontSize,
      transition: 'all 0.3 ease',
      borderRadius: '5px',
      cursor: 'pointer',
      textTransform: 'initial'
    },
    '&&:disabled, &&.Mui-disabled': {
      background: '#949494',
      borderColor: '#949494',
      color: '#FFF',
      filter: 'grayscale(100%)',
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  },
  formButtonDisabled: {
    fontFamily: theme.typography.fontFamily,
    outline: '0',
    background: '#990033',
    width: '40%',
    height: '20%',
    border: '0',
    padding: '10px',
    color: '#FFFFFF',
    fontSize: theme.typography.fontSize,
    transition: 'all 0.3 ease',
    borderRadius: '5px',
    marginBottom: '20px',
    opacity: '0.7'
  }
}));
